module.exports = [{
      plugin: require('../plugins/gatsby-plugin-thumbor/gatsby-browser.js'),
      options: {"plugins":[],"breakpoints":[768,1280,1920]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-tagmanager@5.14.0_gatsby@5.16.1_@types+webpack@4.41.40_babel-eslin_bc76ec08d79ea02849147b0ed41de5eb/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-KWZFNV8","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_@types+webpack@4.41.40_babel-eslint@10.1.0_eslint@9.34.0_jiti@1.21.7___en_e96eb35e8d682c3a6db6e87830bec7b4/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
